import { prepareRequest } from "../../index.js";
import { setParamsToURL } from "../../index.js"
import { BASKET_API_URL_LIST }from "../../routes/basket/index.js";
import  store  from '../../../state/store';

async function getBasketCategoryList(params, body, urlSegments) {
  let config= {
    headers:{
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "GET",
    url: setParamsToURL(BASKET_API_URL_LIST.CATEGORY_LIST_URL,params,urlSegments),
    post: body
  }
  return prepareRequest(config,request,true);
}

async function getBasketCategorySingle(params, body, urlSegments) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "GET",
      url: setParamsToURL(BASKET_API_URL_LIST.CATEGORY_SINGLE_URL,params,urlSegments),
      post: body
    }
    return prepareRequest(config,request,true);
  }

async function addBasketCategory(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(BASKET_API_URL_LIST.CATEGORY_ADD_URL,params),
      post: body
    }
    return prepareRequest(config,request);
}

async function updateBasketCategory(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(BASKET_API_URL_LIST.CATEGORY_UPDATE_URL,params),
      post: body
    }
    return prepareRequest(config,request);
}


async function deleteBasketCategory(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(BASKET_API_URL_LIST.CATEGORY_DELETE_URL,params),
      post: body
    }
    return prepareRequest(config,request);
}

async function getBasketList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(BASKET_API_URL_LIST.BASKET_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getStockBasketList(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(BASKET_API_URL_LIST.STOCK_BASKET_LIST_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getStockBasketSingle(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(BASKET_API_URL_LIST.STOCK_BASKET_SINGLE_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getBasketSingle(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(BASKET_API_URL_LIST.BASKET_SINGLE_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function addBasket(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(BASKET_API_URL_LIST.BASKET_ADD_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function updateBasket(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(BASKET_API_URL_LIST.BASKET_UPDATE_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}
async function updateStockBasket(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(BASKET_API_URL_LIST.STOCK_BASKET_UPDATE_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function addStockBasket(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(BASKET_API_URL_LIST.STOCK_BASKET_ADD_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function deleteStockBasket(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(BASKET_API_URL_LIST.STOCK_BASKET_DELETE_URL,params),
        post: body
    }
    return prepareRequest(config,request);
}

async function deleteBasket(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(BASKET_API_URL_LIST.BASKET_DELETE_URL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request);
}

export {
    getBasketCategoryList,
    addBasketCategory,
    updateBasketCategory,
    deleteBasketCategory,
    getBasketCategorySingle,
    getBasketList,
    addBasket,
    getStockBasketList,
    addStockBasket,
    getStockBasketSingle,
    getBasketSingle,
    deleteStockBasket,
    deleteBasket,
    updateBasket,
    updateStockBasket,
};
